export default import.meta.ROLLUP_FILE_URL_XjaK_neJ_F0WKA57l27oTw